<template>
  <div class="">
    <!-- <a class="phone-nav" @click="phoneclick"><i class="fa fa-list"></i></a> -->
    <el-drawer
    v-if='pcshow'
      title="我是标题"
      :visible.sync="menutopshow"
      direction="ttb"
      size="100%"
      :with-header="false"
    >
      <img
        src="@/assets/buchong/last.png"
        style="height: 100%; width: 100%"
      />
      <div class="daohangnew">
        导航
        <a style="color: #fff">
          <img
            src="../assets/public/topmenu.png"
            style="width: 40px; height: 40px"
            @click="closemenu()"
        /></a>
      </div>
      <Menutop></Menutop>
    </el-drawer>

    <el-drawer v-if='!pcshow'
      title="我是标题"
      :visible.sync="menutopshow"
      direction="ttb"
      size="100%"
      :with-header="false"
    >
      <img
        src="@/assets/buchong/last.png"
        style="height: 100%; width: 100%"
      />
      <div style="position: absolute; top: 10%; left: 5%;z-index: 1;">
        <a style="color: #fff">
          <img
            src="../assets/public/topmenu.png"
            style="width: 40px; height: 40px"
            @click="closemenu()"
        /></a>
      </div>
      <MenutopForPhone></MenutopForPhone>
    </el-drawer>

    <!-- <div class="banner" style="background:#E6E6E6"> -->
    <div style="height:473.16px;overflow:hidden" v-if="pcshow">
      <a
        ><img
          src="../assets/xqsimage/banner1.png"
          class="dongtai"
          style="width: 100%"
        />
      </a>

      <div class="daohangnew">
        导航
        <a @click="backIndex()"
          ><img
            src="../assets/public/backindex.png"
            style="widthL40px;height:40px"
        /></a>
      </div>

       <div style="position: Absolute; top: 10%; right: 5%">
        <a @click="backXQSIndex()">
        <img src="../assets/public/fanhuizhuye.png" style="widthL38px;height:38px"/>
        </a>
      </div>

      <!-- 顶部大标题显示   -->
      <div class="headerMenu">
        <div style="font-size:35px;color:#840207">
          <div class="company_name">智游西樵山</div>
          <div class="company_introduce">Intelligent Tourism</div>
          <div class="company_name" style="margin-top:-20px">
            <img src="../assets/public/xiahua.png" />
          </div>
        </div>
      </div>
    </div>

     <!-- 手机顶部 //顶部图片 顶部图标 -->
    <div v-if='!pcshow' style=";overflow:hidden" >
      <a
        ><img
          src="../assets/xqsimage/banner1.png"
          class="dongtai"
          style="width: 100%"
      /></a>

      <div style="position: Absolute; top: 10%; left: 5%">
        <a @click="backIndex()"
          ><img
            src="../assets/public/backindex.png"
            style="width:40px;height:40px"
        /></a>
      </div>
      <div style="position: Absolute; top: 10%; right: 5%">
        <a @click="backXQSIndex()"
          ><img
            src="../assets/public/fanhuizhuye.png"
            style="width:40px;height:40px"
        /></a>
      </div>
    </div>

  </div>
</template>
<script>
import { getXUYOUlist } from '@/api/public'
import Menutop from './menutop'
import MenutopForPhone from './menutopForPhone'

export default {
  components: { Menutop, MenutopForPhone },
  props: ['showValue'],
  data () {
    return {
      menutopshow: false,
      menuItem1Show: false,
      menuItem2Show: false,
      menuItem3Show: false,
      menuItem4Show: false,
      menuItem5Show: false,
      menuItem6Show: false,
      showPage: false,
      pcshow: true,
      style: {},
      china: '',
      english: '',
      listCaiDan: [],
      styletable: { color: '#840207' },
      mapStyle: { color: 'black' },
      dataList: []
    }
  },
  created () {
    if (this._isMobile()) {
      this.style.height = 50 + 'px'
      this.pcshow = false
    } else {
      this.pcshow = true
      window.addEventListener('scroll', this.handleScroll)
    }
    this.initXYMenu()
  },
  mounted () {},
  methods: {
    backXQSIndex () {
      window.location.href = 'http://www.xiqiaoshantour.com/index'
    },
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    initXYMenu () {
      getXUYOUlist().then(response => {
        var list = response.data
        this.listCaiDan = list.sort(this.compare('sort'))
        console.log('listCaiDan:', this.listCaiDan)
        this.inittopmenu()
      })
    },
    inittopmenu () {
      if (this.$route.query.ids == 1) {
        this.china = this.listCaiDan[0].title
        this.english = this.listCaiDan[0].enTitle
      } else if (this.$route.query.ids == 2) {
        this.china = this.listCaiDan[1].title
        this.english = this.listCaiDan[1].enTitle
      } else if (this.$route.query.ids == 3) {
        this.china = this.listCaiDan[2].title
        this.english = this.listCaiDan[2].enTitle
      } else if (sessionStorage.getItem('ids2') == 1) {
        this.china = this.listCaiDan[0].title
        this.english = this.listCaiDan[0].enTitle
      } else if (sessionStorage.getItem('ids2') == 2) {
        this.china = this.listCaiDan[1].title
        this.english = this.listCaiDan[1].enTitle
      } else if (sessionStorage.getItem('ids2') == 3) {
        this.china = this.listCaiDan[2].title
        this.english = this.listCaiDan[2].enTitle
      } else {
        this.china = this.listCaiDan[0].title
        this.english = this.listCaiDan[0].enTitle
      }
    },
    closemenu () {
      this.menutopshow = false
    },
    backIndex () {
      this.menutopshow = true
    },
    handleChange (index) {
      console.log(index)
    },
    rountPage (index) {
      if (index == 1) {
        sessionStorage.setItem('ids2', 1)
        this.$router.push({
          path: '/InfomationAllOver'
        })
      }
      if (index == 2) {
        sessionStorage.setItem('ids2', 2)
        this.$router.push({
          path: '/InfomationAllOverForWork'
        })
      }
      if (index == 3) {
        sessionStorage.setItem('ids2', 3)
        this.$router.push({
          path: '/InfomationAllOverForNotion'
        })
      }
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    phoneclick () {
      this.showPage = !this.showPage
    },
    handleScroll () {
      this.menuItem1Show = false
      this.menuItem2Show = false
      this.menuItem3Show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem6Show = false
    },
    mouseover1 () {
      this.menuItem1Show = true
      this.menuItem2Show = false
      this.menuItem3Show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem6Show = false
    },
    mouseleave1 () {
      this.menuItem1Show = false
    },
    mouseover2 () {
      this.menuItem1Show = false
      this.menuItem2Show = true
      this.menuItem3Show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem6Show = false
    },
    mouseleave2 () {
      this.menuItem2Show = false
    },
    mouseover3 () {
      this.menuItem1Show = false
      this.menuItem2Show = false
      this.menuItem3Show = true
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem6Show = false
    },
    mouseleave3 () {
      this.menuItem3Show = false
    },
    mouseover4 () {
      this.menuItem1Show = false
      this.menuItem2Show = false
      this.menuItem3Show = false
      this.menuItem4Show = true
      this.menuItem5Show = false
      this.menuItem6Show = false
    },
    mouseleave4 () {
      this.menuItem4Show = false
    },
    mouseover5 () {
      this.menuItem1Show = false
      this.menuItem2Show = false
      this.menuItem3Show = false
      this.menuItem4Show = false
      this.menuItem5Show = true
      this.menuItem6Show = false
    },
    mouseleave5 () {
      this.menuItem5Show = false
    },
    mouseover6 () {
      this.menuItem6Show = true
      this.menuItem2Show = false
      this.menuItem3Show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem1Show = false
    },
    mouseleave6 () {
      this.menuItem6Show = false
    }
  }
}
</script>

<style>
.dongtai {
  visibility: visible !important;
  -webkit-animation: scaleUpDown 6s forwards
    cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation: scaleUpDown 6s forwards cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
@-webkit-keyframes scaleUpDown {
  from {
    -webkit-transform: scale(1.18);
    transform: scale(1.18);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes scaleUpDown {
  from {
    -webkit-transform: scale(1.18);
    transform: scale(1.18);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

li {
  margin-bottom: 10px;
  color: #7f7f7f;
}
.folatL30 {
  float: left;
  width: 30%;
}
a {
  color: #7f7f7f;
}

.marBot5 {
  margin-bottom: 5px;
  margin-right: 10px;
}
.top {
  /* 设置宽度高度背景颜色 */
  height: auto; /*高度改为自动高度*/
  width: 100%;
  margin-left: 0;
  height: 112px;
  background: #e6e6e6;
  /* background: white; */
  position: absolute; /*固定在顶部*/
  top: 0; /*离顶部的距离为0*/
}
.logo {
  position: absolute;
  z-index: 999;
}
.top ul {
  /* 清除ul标签的默认样式 */
  width: auto; /*宽度也改为自动*/
  list-style-type: none;
  white-space: nowrap;
  overflow: hidden;
  font-size: 18px;
  margin: 0px;
  margin-left: calc(50vw - 656px);
  /* margin-top: 0;          */
}
.top li {
  float: left; /* 使li内容横向浮动，即横向排列  */
  margin-right: 2%; /* 两个li之间的距离*/
  text-align: center;
  line-height: 30px;
  position: relative;
  overflow: hidden;
}

.top li a {
  /* 设置链接内容显示的格式*/
  display: block; /* 把链接显示为块元素可使整个链接区域可点击 */
  text-align: center;
  overflow: hidden;
  text-decoration: none; /* 去除下划线 */
  font-weight: 400;
  color: #333333;
  font-family: "Microsoft YaHei";
  padding: 0px;
  padding-top: 41px;
  padding-bottom: 41px;
}
.top li a:hover {
  /* 鼠标选中时背景变为黑色 */
  /* background-color: #111; */
  color: #840207;
}
.top ul li ul {
  /* 设置二级菜单 */
  margin-left: -0.2px;
  background: rgb(189, 181, 181);
  position: relative;
  display: none; /* 默认隐藏二级菜单的内容 */
  width: 100px;
}
.top ul li ul li {
  /* 二级菜单li内容的显示 */

  float: none;
  text-align: center;
}
.top ul li:hover ul {
  /* 鼠标选中二级菜单内容时 */
  display: block;

  height: 512px;
  background: #9c242a;
  border-radius: 10px;
}
.menuItem6 {
  width: 348px;
  height: 512px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem1 {
  width: 348px;
  height: 258px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem2 {
  width: 348px;
  height: 158px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem3 {
  width: 600px;
  height: 330px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem4 {
  width: 348px;
  height: 360px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem5 {
  width: 348px;
  height: 380px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.secondMenuItemFont {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #e6e6e6;
  line-height: 30px;
  text-align: left;
}

.firstMenufont {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #e6e6e6;
  line-height: 40px;
  cursor: pointer;
}
.firstMenufontMobile {
  font-weight: 300;
  font-size: 14px;
  font-family: "Microsoft YaHei";
}
.tab {
  white-space: nowrap;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  overflow-y: hidden;
  text-align: left;
  padding-left: 2%;
}
.tab .table-item {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-block;
}
.headerMenu {
  position: Absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  text-align: left;
}
.pcMenuItem_1 {
  width: 100%;
  background-color: rgb(227 227 227 / 84%);
}
.pcMenuItem_2 {
  margin: 0px auto;
  height: 56px;
  width: 1200px;
  background-color: #840207;
  font-size: 14px;
}
.pcMenuItem_3 {
  float: left;
  width: 150px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/headerforclever.vue